var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/16px/Info/Subscription_Management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,2 C15.1045695,2 16,2.8954305 16,4 L16,12 C16,13.1045695 15.1045695,14 14,14 L2,14 C0.8954305,14 0,13.1045695 0,12 L0,4 C0,2.8954305 0.8954305,2 2,2 L14,2 Z M14.75,7 L1.25,7 L1.25,11.5833333 C1.25,12.0534329 1.62225304,12.4408816 2.10182963,12.4938329 L2.21428571,12.5 L13.7857143,12.5 C14.2802346,12.5 14.6878105,12.1461298 14.7435125,11.690236 L14.75,11.5833333 L14.75,7 Z M3.25,10 C3.66421356,10 4,10.3357864 4,10.75 C4,11.1642136 3.66421356,11.5 3.25,11.5 C2.83578644,11.5 2.5,11.1642136 2.5,10.75 C2.5,10.3357864 2.83578644,10 3.25,10 Z M6.25,10 C6.66421356,10 7,10.3357864 7,10.75 C7,11.1642136 6.66421356,11.5 6.25,11.5 C5.83578644,11.5 5.5,11.1642136 5.5,10.75 C5.5,10.3357864 5.83578644,10 6.25,10 Z M9.25,10 C9.66421356,10 10,10.3357864 10,10.75 C10,11.1642136 9.66421356,11.5 9.25,11.5 C8.83578644,11.5 8.5,11.1642136 8.5,10.75 C8.5,10.3357864 8.83578644,10 9.25,10 Z M13.7857143,3.25 L2.21428571,3.25 C1.71976544,3.25 1.31218952,3.76472025 1.25648746,4.4278385 L1.25,4.58333333 L1.25,5.25 L14.75,5.25 L14.75,4.58333333 C14.75,3.89955221 14.377747,3.33599045 13.8981704,3.25897031 L13.7857143,3.25 Z",
    id: "Shape",
    fill: "#3368FF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionManagement);
export default __webpack_public_path__ + "static/media/subscription-management.48c2dbfeb531aa333681e02267d30952.svg";
export { ForwardRef as ReactComponent };